function getProfileImage(value: string): string {
  if (value.includes('@rooney.com')) {
    const currentMonth = new Date().getMonth();

    // Halloween!
    if (currentMonth === 9) {
      return 'media/misc/profile-halloween.png';
    }

    // Christmas!
    if (currentMonth === 11) {
      return 'media/misc/profile-santa-claus.png';
    }

    // Easter!
    if (currentMonth === 3) {
      return 'media/misc/profile-bunny.png';
    }

    return 'media/misc/profile-neo.png';
  }

  return 'media/misc/profile-place.jpg';
}

export default getProfileImage;
